import FormWidget from "../form-widget.js";

interface SelectListWidgetOptions {
    multiple: boolean;
    submitOnChange: boolean;
}

const defaultOptions: SelectListWidgetOptions = {
    multiple: false,
    submitOnChange: false,
};

class SelectListWidget extends FormWidget {
    protected options:SelectListWidgetOptions;
    public override init() {
        const config = Object.assign({}, this.config, this.element.dataset);
        this.options = this.assignConfig<SelectListWidgetOptions>(defaultOptions, config);
    }
    public override process() {
        const fieldEl = this.element as HTMLSelectElement;
        fieldEl.style.display = 'none';

        const listEl = document.createElement('div');
        listEl.classList.add('form-select-list', 'list-group');
        fieldEl.after(listEl);

        const optionMap = new Map<HTMLElement, HTMLOptionElement>();

        const updateField = () => {
            let values: string[] = [];
            optionMap.forEach((optionEl: HTMLOptionElement, itemEl: HTMLElement) => {
                let value = optionEl.getAttribute('value') ?? optionEl.innerHTML;
                if(itemEl.classList.contains('selected')) {
                    values.push(value);
                }
            });
            fieldEl.value = values.join(',');
            fieldEl.dispatchEvent(new Event('change'));
        };

        fieldEl.querySelectorAll<HTMLOptionElement>('option').forEach((optionEl: HTMLOptionElement) => {
            let label = optionEl.innerHTML;

            const itemEl = document.createElement('div');

            optionMap.set(itemEl, optionEl);

            itemEl.classList.add('list-item', 'list-group-item');
            if(optionEl.getAttribute('selected')) {
                itemEl.classList.add('selected');
            }
            itemEl.innerHTML = label;
            itemEl.addEventListener('click', (ev: MouseEvent) => {
                if(!fieldEl.multiple) {
                    optionMap.forEach((oEl: HTMLOptionElement, el: HTMLElement) => {
                        if(el == itemEl) {
                            return;
                        }
                        el.classList.remove('selected');
                    });
                }
                if(itemEl.classList.contains('selected')) {
                    itemEl.classList.remove('selected');
                } else {
                    itemEl.classList.add('selected');
                }
                updateField();
            });
            listEl.append(itemEl);
        });
        updateField();
    }

}

export default SelectListWidget;
